import { useMutation, useQueryClient } from '@tanstack/react-query';
import { directoryApi, type UpdateAccountRequest } from '../client';
import { useSupportAccounts } from './useSupportAccounts';

/**
 * Rename an account, or — for Stratum support — move its domain.
 *
 * <p>
 * Invalidates the support-account list, which is what every screen in My Hub
 * reads the account from: without it the header, the picker and the strip would
 * all keep showing the old name until a reload.
 * </p>
 */
export function useUpdateAccount() {
  const queryClient = useQueryClient();

  return useMutation<string, Error, UpdateAccountRequest>({
    mutationFn: (body) => directoryApi.updateAccount(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useSupportAccounts.queryKey });
    },
  });
}
